export const renderMessage = (content: string) => {
  const unescaped = content.replace(/\\n/g, "\n");

  const normalized = unescaped.replace(/\r\n/g, "\n");

  const lines = normalized.split("\n");

  return lines.map((line, lineIndex) => {
    if (line.trim() === "") {
      return <br key={`empty-${lineIndex}`} />;
    }

    const parts = line.split(/(\*[^*]+\*)/g);

    return (
      <span key={lineIndex}>
        {parts.map((part, index) =>
          part.startsWith("*") && part.endsWith("*") ? (
            <strong key={index}>{part.slice(1, -1)}</strong>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
        <br />
      </span>
    );
  });
};

export const renderInlineBoldPreview = (content: string) => {
  const singleLine = content
    .replace(/\\n/g, " ")
    .replace(/\n/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const parts = singleLine.split(/(\*[^*]+\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith("*") && part.endsWith("*")) {
      return <strong key={index}>{part.slice(1, -1)}</strong>;
    }

    return <span key={index}>{part}</span>;
  });
};
